import React, { Component } from 'react';

import { helpCircleOutline as help, arrowForwardOutline as forward } from 'ionicons/icons';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonPage,
  IonToolbar,
  IonButtons,
  IonBackButton,
  withIonLifeCycle,
  IonButton,
  IonIcon,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
} from '@ionic/react';

import ShopService from '../services/shopservice';

import '../theme/service.css';

class ServiceList extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.files = React.createRef();
    this.pickedDateRef = React.createRef('');
    this.selectedTimeRef = React.createRef('');
    this.selectedStaffIdRef = React.createRef('');
    this.noteRef = React.createRef('');
    this.date = React.createRef('');
    this.serviceRef = React.createRef('');
    this.profileRef = React.createRef('');

    this.state = {
      services: [],
      shopServiceModal: false,
      shopModal: false,
      availableDate: [],
      pickedDateTime: null,
      isModalOpen: false,
      isActive: '',
      calendarDayProgression: [],
      category: [],
      selectedService: [],
      shopServices: [],
      selectedShopService: null,
      profile: null,
      shop_service_id: null,
      id: null,
    };

    this.setService = this.setService.bind(this);
    this.textHandler = this.textHandler.bind(this);
    this.requestService = this.requestService.bind(this);
  }

  async ionViewWillEnter() {
    await this.setService(this.props.match.params.id, false);

    try {
      const { id } = this.props.match.params;
      let response = await ShopService.find(id);

      const { category } = response.data;
      const { services, shop_service } = response.data.data;

      this.setState({
        services,
        shopServices: shop_service,
        category,
        id,
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.props.loader.current.dismiss();
    }
  }

  async ionViewWillLeave() {
    this.setState({ isModalOpen: false });
    this.setState({ pickedDateTime: null });
    this.setState({ availableDate: null });
    this.setState({ isActive: '' });
    this.setState({ calendarDayProgression: [] });

    this.serviceRef.current = '';
    this.profileRef.current = '';
    this.selectedTimeRef.current = '';
    this.pickedDateRef.current = '';
    this.selectedStaffIdRef.current = '';
    this.noteRef.current = '';
  }

  async textHandler(event) {
    await this.setState({
      [event.target.name]: event.detail.value,
    });
  }

  async setService(id) {
    const selectedService = this.state.services.find((service) => service && service.id === id);
    this.setState({ selectedService, shopServiceModal: true });
  }

  async requestService(e) {
    if (!this.state.selectedShopService) {
      console.error('selectedShopService is null');
      return;
    }
    const shop_service_id = this.state.selectedShopService.id;
    const note = this.state.note;
    const selectedService = this.state.selectedShopService;

    try {
      let shopservice = {
        shop_service_id: shop_service_id,
        shop_service_name: selectedService.name,
        note: note,
      };

      await ShopService.create(shopservice);
      this.setState({
        shop_service_id: undefined,
        note: '',
        shopServiceModal: false,
      });

      this.props.toast.current.add({
        message: `Richiesta inviata correttamente`,
      });
    } catch (error) {
      console.error(error);
      this.props.toast.current.add({
        message: `Impossibile inviare la richiesta`,
        color: 'warning',
      });
    }
  }

  formatDate(date) {
    return new Date(date).toLocaleDateString('it-IT');
  }

  async setServicePrenotabile(id) {
    const selectedShopService = this.state.shopServices.find((service) => service.id === id);

    if (!selectedShopService) {
      console.error('Servizio non trovato con ID:', id);
      return;
    }

    this.setState({
      selectedShopService,
      shopModal: true,
    });
  }
  reset() {
    this.pickedDateRef.current = '';
    this.setState({ pickedDateTime: null });
    this.setState({ isActive: '' });
  }

  render() {
    const { services, shopServices, id } = this.state;

    return (
      <IonPage>
        <>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonBackButton defaultHref="/app/home" />
              </IonButtons>
              <IonTitle>Prenota un Servizio</IonTitle>
              <IonButtons slot="end">
                <IonButton href="/app/help/Services">
                  <IonIcon icon={help} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>

          <IonContent className="service-list-page">
            <div className="service-list-container">
              <IonCard className="service-list-header" color="light">
                <IonCardHeader>
                  <IonCardTitle>Prenota un Servizio</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <p>
                    Ecco l'elenco dei nostri servizi,
                    <br />
                    seleziona il servizio che ti interessa
                  </p>
                </IonCardContent>
              </IonCard>

              <div className="service-grid">
                {/* Servizi prenotabili */}
                {services
                  .filter((service) => service)
                  .map((service) => {
                    const link = `/app/service/category/${id}/${service.id}`;
                    return (
                      <IonCard key={service.id} className="service-card" onClick={() => this.props.history.push(link)}>
                        <div className="service-card-image">
                          {service.image ? (
                            <img src={service.image} alt={service.name} />
                          ) : (
                            <div className="service-card-image-placeholder">
                              <IonIcon icon={forward} />
                            </div>
                          )}
                        </div>

                        <IonCardHeader>
                          <IonCardTitle>{service.name}</IonCardTitle>
                        </IonCardHeader>

                        <IonCardContent>
                          <p className="service-card-description">
                            <span dangerouslySetInnerHTML={{ __html: service.description }}></span>
                          </p>

                          <div className="service-card-footer">
                            <IonButton
                              className="service-card-button"
                              fill="solid"
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.props.history.push(link);
                              }}
                            >
                              Prenota
                            </IonButton>

                            <IonIcon icon={forward} color="medium" />
                          </div>
                        </IonCardContent>
                      </IonCard>
                    );
                  })}

                {/* Servizi shop */}
                {shopServices
                  .filter((shopService) => shopService)
                  .map((shopService, i) => {
                    const link = `/app/service/category/${id}/shop/${shopService.id}`;
                    return (
                      <IonCard key={`shop-${i}`} className="service-card" onClick={() => this.props.history.push(link)}>
                        <div className="service-card-image">
                          {shopService.image ? (
                            <img src={shopService.image} alt={shopService.name} />
                          ) : (
                            <div className="service-card-image-placeholder">
                              <IonIcon icon={forward} />
                            </div>
                          )}
                        </div>

                        <IonCardHeader>
                          <IonCardTitle>{shopService.name}</IonCardTitle>
                        </IonCardHeader>

                        <IonCardContent>
                          <p className="service-card-description">
                            <span dangerouslySetInnerHTML={{ __html: shopService.description }}></span>
                          </p>

                          <div className="service-card-footer">
                            <IonButton
                              className="service-card-button"
                              fill="solid"
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.props.history.push(link);
                              }}
                            >
                              Dettagli
                            </IonButton>

                            <IonIcon icon={forward} color="medium" />
                          </div>
                        </IonCardContent>
                      </IonCard>
                    );
                  })}
              </div>
            </div>
          </IonContent>
        </>
      </IonPage>
    );
  }
}

export default withIonLifeCycle(ServiceList);
